<template>
  <v-row v-if="props_data != null" class="box-content" justify="center">
    <v-col xs="12" sm="12" md="12" lg="4" xl="4" cols="12">
      <Carousel :images="images" />
      <!-- <v-card outlined>
        <v-carousel hide-delimiter-background hide-delimiters continuous height="200">
          <v-carousel-item v-for="(slide, i) in images" :key="i" :src="slide"></v-carousel-item>
        </v-carousel>
      </v-card>-->
    </v-col>
    <v-col xs="12" sm="12" md="12" lg="8" xl="8" @click="goTo">
      <v-card class="mx-auto searchcard" flat>
        <v-list-item three-line>
          <v-list-item-content>
            <div
              v-if="props_data.surface != null"
              class="ct regular_text grey_7--text"
            >
              {{ parseInt(this.props_data.surface).toLocaleString() }}m²
            </div>
            <div
              v-if="props_data.name != null"
              class="ct regular-app-bar bold grey_8--text"
            >
              {{ props_data.name }} / {{ props_data.localisation }}
            </div>
            <div
              :v-if="props_data.search_description"
              class="ct regular_text grey_7--text"
            >
              {{ props_data.search_description }}
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content class="pt-0 pb-0">
            <v-row no-gutters justify="center" align="center">
              <div class="ct grey_7--text regular_text text-no-wrap">
                USAGES POSSIBLES:
              </div>
              <v-row no-gutters justify="start" align="center">
                <template v-for="item in props_data.properties">
                  <span
                    :key="item"
                    class="grey_7--text regular_text text-no-wrap pl-2"
                    v-if="is_usage(item)"
                  >
                    <img
                      :src="require('../../assets/svg/green-point.svg')"
                      height="8px"
                    />
                    {{ getUsageName(item) }}
                  </span>
                </template>
              </v-row>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content class="pt-0 pb-0">
            <v-row align="center" justify="space-between">
              <v-col v-if="props_data.loyer_mensuel" cols="12" md="4">
                <div class="price text-no-wrap monthly">
                  {{ parseInt(props_data.loyer_mensuel).toLocaleString() }}€ /
                  mois
                </div>
              </v-col>
              <!-- <v-col v-if="props_data.loyer_mensuel" cols="12" md="3">
                <div class="price text-no-wrap daily">
                  {{ Math.round(props_data.loyer_mensuel / 31) }}€ / jours
                </div>
              </v-col>-->
              <v-col
                v-if="props_data.loyer_annuel != undefined"
                cols="12"
                md="3"
              >
                <div class="price text-no-wrap daily">
                  {{ parseInt(props_data.loyer_annuel).toLocaleString() }}€ / m2
                  / an HT CC
                </div>
              </v-col>
              <v-col v-else-if="props_data.loyer_mensuel" cols="12" md="3">
                <div class="price text-no-wrap daily">
                  {{ parseInt(computePrice).toLocaleString() }}€ / m2 / an HT CC
                </div>
              </v-col>
              <v-spacer />
              <v-col cols="12" md="2">
                <div>
                  <v-btn
                    icon
                    @click.native="like()"
                    :color="isLiked ? 'pink' : 'grey'"
                  >
                    <v-icon id="love">mdi-heart</v-icon>
                  </v-btn>
                  <v-btn @click.native="share()" icon color="grey">
                    <v-icon id="share">mdi-share</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <!-- <p class="ps grey_7--text regular_text" v-if="props_data.loyer_mensuel">
          Prix mensuel indicatif.
        </p>-->
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Carousel from "@/components/Carousel";

import { NOT_LOGGED_IN, LIKED, WIP } from "@/utils/snackbar_constants";

import { like } from "@/services/like";
import { getImages } from "@/services/image";

export default {
  props: ["props_data"],
  components: {
    Carousel,
  },
  data() {
    return {
      images: [],
    };
  },
  methods: {
    ...mapActions({
      notify: "notificationModule/notify",
    }),
    like() {
      if (!this.haveUser) {
        this.notify(NOT_LOGGED_IN);
        return;
      }
      like(this.props_data.id, this.getLikes, () => {
        this.notify(LIKED);
      });
    },
    share() {
      this.notify(WIP);
      console.log("Feature not implemented");
      // TODO:
      // Copy the link
      // Pop up snack bar
    },
    onClick() {
      // console.log(this.props_data.id);
    },
    goTo(elt) {
      if (elt.srcElement.id != "love" && elt.srcElement.id != "share")
        this.$router.push({ path: "/bien/" + this.props_data.id });
    },
    getUsageName(id) {
      var data = this.getData.usage.data;
      var res = "";
      data.forEach((element) => {
        if (element.id == id) {
          res = element.name;
        }
      });
      return res;
    },
    is_usage(item) {
      let res = item.includes("usage");
      return res;
    },
  },
  computed: {
    ...mapGetters({
      haveUser: "userModule/haveUser",
      getData: "dataModule/getData",
      getLikes: "likeModule/getLikes",
    }),
    isLiked() {
      let arr = this.getLikes;
      let ret = false;
      arr.forEach((e) => {
        if (e === this.props_data.id) {
          ret = true;
        }
      });
      return ret;
    },
    computePrice() {
      if (
        this.props_data == null ||
        this.props_data.loyer_mensuel == null ||
        this.props_data.surface == null ||
        this.props_data.surface == 0
      ) {
        return "Erreur";
      }
      return Math.round(
        (this.props_data.loyer_mensuel * 12) / this.props_data.surface
      );
    },
  },
  beforeMount() {
    this.images = getImages(this.props_data.id, (images) => {
      this.images = images;
    });
  },
};
</script>

<style scoped>
.searchcard {
  background-color: white !important;
  border-radius: 14px !important;
  border: 1px solid #bcccdc;
}
.ct {
  margin: 5px;
}

.point-icon {
  font-size: 55px !important;
  font-family: initial !important;
}

.box-content {
  padding: 5px;
  margin: 0;
}

.prices {
  display: flex;
}
.prices div {
  font-size: 1em;
  padding: 10px;
  margin: 10px;
}

.price {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.monthly {
  background: #e0fcff;
  border-radius: 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #044e54;
}

.daily {
  font-size: 12px;
  line-height: 20px;
  color: #486581;
}

.card-icon {
  display: flex;
  align-self: flex-end;
}

.ps {
  margin-left: 3em;
  font-size: 10px;
}
</style>
